import React from 'react';
import { motion } from 'framer-motion';
const GALLERY_IMAGES = [{
  src: 'https://images.unsplash.com/photo-1541614101331-1a5a3a194e92?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  alt: 'Family gathering at restaurant',
  className: 'col-span-2 row-span-2 aspect-square md:aspect-auto'
}, {
  src: 'https://images.unsplash.com/photo-1577219491135-ce391730fb2c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  alt: 'Chef in kitchen',
  className: 'col-span-1 row-span-1 aspect-square'
}, {
  src: 'https://images.unsplash.com/photo-1559339352-11d035aa65de?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  alt: 'Restaurant interior',
  className: 'col-span-1 row-span-1 aspect-square'
}, {
  src: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  alt: 'Dining experience',
  className: 'col-span-2 row-span-1 aspect-[2/1]'
}];
export function FamilyGallery() {
  return <section className="py-24 px-6 md:px-12 bg-neutral-950" data-id="element-28">
      <div className="max-w-7xl mx-auto" data-id="element-29">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-30">
          <h2 className="text-3xl md:text-4xl font-serif text-stone-50 mb-4" data-id="element-31">
            Moments & Memories
          </h2>
          <p className="text-stone-400 font-light" data-id="element-32">
            A glimpse into our kitchens and dining rooms.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[200px] md:auto-rows-[300px]" data-id="element-33">
          {GALLERY_IMAGES.map((image, index) => <motion.div key={index} className={`relative overflow-hidden group ${image.className}`} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} data-id="element-34">
              <div className="absolute inset-0 bg-neutral-900/20 z-10 transition-opacity duration-500 group-hover:opacity-0" data-id="element-35"></div>
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105 grayscale hover:grayscale-0" data-id="element-36" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}